import { render } from "./AuthorsTable.vue?vue&type=template&id=c91f46b8&scoped=true"
import script from "./AuthorsTable.vue?vue&type=script&lang=js"
export * from "./AuthorsTable.vue?vue&type=script&lang=js"

import "./AuthorsTable.vue?vue&type=style&index=0&id=c91f46b8&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c91f46b8"]])

export default __exports__